import { atom } from "recoil";

const manualsAtom = atom({

    key:"manuals",
    default: null

});

export default manualsAtom;